import { photosMessages as messages } from '../VenuePage.messages';

export const parseAsDataURL = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
    reader.readAsDataURL(file);
  });

export const getImage = url =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = error => reject(error);
    img.src = url;
  });

export const getScaledImageDataUrl = (img, outputType, areaScaleFactor) => {
  // since we'll apply our scale factor in two dimensions, we take the
  // square root of our desired surface area scaling to get the linear scalar
  const linearScaleFactor = Math.sqrt(areaScaleFactor);
  const targetWidth = linearScaleFactor * img.width;
  const targetHeight = linearScaleFactor * img.height;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  canvas.width = targetWidth;
  canvas.height = targetHeight;
  ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

  const imageDataUrl = canvas.toDataURL(outputType);
  return Promise.resolve(imageDataUrl);
};

export const validateImageDimensions = (imageType, width, height, minWidth, minHeight) => {
  const isValid = true;

  if (imageType === 'logo' && width < minWidth) {
    return [!isValid, messages.error.logoTooSmall, { minWidth }];
  }
  if (width < minWidth || height < minHeight) {
    return [!isValid, messages.error.tooSmall, { minWidth, minHeight }];
  }

  return [isValid];
};
